import { defineComponent as _defineComponent } from 'vue';
import {} from "axios";
import { BModal } from "bootstrap-vue";
import { computed, ref } from "vue";
import {} from "@/api/schema";
export default /*#__PURE__*/ _defineComponent({
    __name: 'OperationErrorDialog',
    props: {
        operationError: null
    },
    emits: ["hide"],
    setup(__props, { emit }) {
        const props = __props;
        const show = ref(() => props.operationError != null);
        const isPartialSuccess = computed(() => {
            return props.operationError?.result?.success_count > 0;
        });
        const success_count = computed(() => {
            return props.operationError?.result?.success_count || 0;
        });
        const error_count = computed(() => {
            return props.operationError?.result?.errors.length || 0;
        });
        const reasons = computed(() => {
            if (props.operationError && props.operationError.result) {
                return [...new Set(props.operationError.result.errors.map((e) => e.error))];
            }
            const response_error = props.operationError?.errorMessage?.response?.data?.err_msg;
            if (response_error) {
                return [response_error];
            }
            return [];
        });
        const title = computed(() => {
            return isPartialSuccess.value ? "Some items could not be processed" : "Something went wrong...";
        });
        const titleVariant = computed(() => {
            return isPartialSuccess.value ? "warning" : "danger";
        });
        const errorMessage = computed(() => {
            return props.operationError?.errorMessage?.message;
        });
        function onHide() {
            emit("hide");
        }
        return { __sfc: true, props, emit, show, isPartialSuccess, success_count, error_count, reasons, title, titleVariant, errorMessage, onHide, BModal };
    }
});
